const PERMISSION_KEY = "core:granted_user";
const PAGE_URL = {
    GRANTED_USER_PAGE: "/admin/core/granted-user"
}

export { PERMISSION_KEY, PAGE_URL }
